import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';
import StepsSlider from '../../../UiComponents/StepsSlider/StepsSlider';
import Gradient from '../../../UiComponents/Gradient/Gradient';

const HomeSteps = ({ stepsData }) => {
  const langToggle = useLanguage;
  return (
    <section className="home-steps" data-scroll-section>
      <div className="content-wrapper">
        <header className="home-steps__header">
          <div
            className="home-steps__count-wrapper"
            data-scroll=""
            data-scroll-speed="-0.5"
            // data-scroll-delay="0.05"
          >
            <span className="home-steps__count">{stepsData.step_count}</span>
          </div>
          <div className="home-steps__title-wrapper">
            <h2 className="home-steps__title">
              {langToggle(stepsData.title_ua, stepsData.title_ru)}
            </h2>
          </div>
        </header>
        <StepsSlider items={stepsData.Steps_Items} />
        <div
          className="home-steps__gradient-wrapper"
          data-scroll=""
          data-scroll-speed="-2.5"
          data-scroll-delay="0.05"
        >
          <div className="home-steps__gradient-wrapper__owerflow">
            <Gradient />
          </div>
        </div>
      </div>
    </section>
  );
};

HomeSteps.propTypes = {
  stepsData: PropTypes.object,
};

export default HomeSteps;
